import { knownColors } from "@mapmycustomers/shared/enum/Color";
import { ColorItemType } from "@mapmycustomers/shared/types/map/PinLegend";

import { DEFAULT_NO_VALUE_COLOR } from "@app/scene/map/components/pinLegends/utils/consts";

import Option from "../types/Option";

const getDefaultColors = (options: Option[], addUnknown: boolean = true): ColorItemType[] => {
  // randomShift helps to choose different colors every time this function is called
  const randomShift = Math.floor(Math.random() * knownColors.length);
  const groupIds = Array.from(new Set(options.map(({ groupId }) => groupId)));

  const colors: ColorItemType[] = options.map(({ groupId, value }, index) => ({
    color:
      knownColors[
        (randomShift + (groupId ? groupIds.indexOf(groupId) : index)) % knownColors.length
      ],
    fieldValue: value,
    weight: 1,
  }));

  if (addUnknown) {
    // add an "unknown" option into the list
    colors.unshift({
      color: DEFAULT_NO_VALUE_COLOR,
      fieldValue: null,
      fieldValueMax: null,
      gradient: false,
      weight: 0,
    });
  }

  return colors;
};

export default getDefaultColors;
